import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { TostMsg } from "../../../App";
import { getLeaveLedgerDetails, getLeaveYear } from "./leaveService";
import LeaveNavBarItems from "./CommonComponents/LeaveNavBarItems";
import LeaveManagerReport from "./CommonComponents/LeaveManagerReport";
import {
  orgSettings,
} from "../../../Services/Global-Services/GlobalServices";
import { Dropdown } from "primereact/dropdown";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { Paginator } from "primereact/paginator";
import { useSelector, useDispatch } from "react-redux";
import moment, { RFC_2822 } from "moment";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/placeholder_profile.png";

function MyLedger() {
  const leaveRequestData = useSelector((state) => state.leave.leaveRequestData);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  const [ledgerDetailsData, setLedgerDetailsData] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  const [IsEmploading, setIsEmploading] = useState(false);
  const [typeAddOnClass, settypeAddOnClass] = useState(null);
  const [selectHierarchyValue, setSelectHierarchyValue] = useState("1");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedEmployeId, setSelectedEmployeId] = useState(userDetails?.EmpId);
  const [leaveYears, setLeaveYear] = useState([]);
  const [selectedStatusValue, setselectedStatusValue] = useState(0);
  const [employeeList, setEmployeeList] = useState(null);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [pageNumber, serPageNumber] = useState(1);
  const [pageSize, serPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  let EDate = new Date()?.toISOString()?.split("T")[0];
  const [filterStartDate, setFilterStartDate] = useState(
    new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 366)
      ?.toISOString()
      ?.split("T")[0]
  );
  const [filterEndDate, setFilterEndDate] = useState(EDate);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let ApllyForOtherEmployeeId;
  const [noData, setNoData] = useState([]);

  useEffect(() => {
    if (leaveRequestData) {
      ApllyForOtherEmployeeId = leaveRequestData?.EmpId;
      setSelectedEmployeId(leaveRequestData?.EmpId);
      getEmployeeIdData(0);
      OrgSettings(leaveRequestData);
      GetLeaveYears();
      setSelectHierarchyValue("3");
      GetMasterSystemAlertList("Leave_Ledger_SubText", 1);
      GetMasterSystemAlertList("Leave_NoLedger", 2);
    } else {
      ApllyForOtherEmployeeId = JSON.parse(
        localStorage.getItem("User") || "{}"
      )?.EmpId;
      OrgSettings(null);
      getEmployeeIdData(1);
      GetLeaveYears();
      GetMasterSystemAlertList("Leave_NoLedger", 2);
      GetMasterSystemAlertList("Leave_Ledger_SubText", 1);
    }
  }, []);

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const OrgSettings = useCallback(async (leaveRequestData) => {
    setIsloading(true);
    let param = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let responce = await orgSettings(param);
      let EndDate = responce?.Data?.filter(
        (element) => element?.KeyName == "LeaveFilterEndDate"
      );
      if (leaveRequestData) {
        EDate = new Date(leaveRequestData?.EndDate)
          ?.toISOString()
          ?.split("T")[0];
        setFilterEndDate(EDate);
      } else {
        if (EndDate[0]?.Value != null) {
          EDate = new Date(EndDate[0]?.Value)?.toISOString()?.split("T")[0];
        } else {
          EDate = new Date()?.toISOString()?.split("T")[0];
        }

        setFilterEndDate(EDate);
        if (EDate && selectHierarchyValue && selectedEmployeId) {
          getLeaveLedgerDataList(pageNumber, pageSize);
        }
      }
    } catch (error) {
      EDate = new Date()?.toISOString()?.split("T")[0];
      setFilterEndDate(EDate);
      setIsloading(false);
    }
  }, []);

  const getLeaveLedgerDataList = async (pageNumber, pageSize) => {
    settypeAddOnClass(selectedStatusValue);
    setIsloading(true);
    let FilterendOfTheDay = new Date(filterEndDate);
    FilterendOfTheDay?.setUTCHours(23, 59, 59, 999);
    const FilterEndDate = FilterendOfTheDay?.toISOString();
    const param = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: userDetails?.EmpId,
      EntryType: selectedStatusValue, //selectedLeaveCatgory,
      HierarchyTypeId: Number(selectHierarchyValue) ?? 0,
      FilterStartDate: new Date(filterStartDate).toISOString() ?? "2008-10-01",
      FilterEndDate: FilterEndDate ?? "2026-10-01",
      EmpId: selectedEmployeId ?? 0,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    try {
      const data = await getLeaveLedgerDetails(param);
      setTotalRecords(data?.Data[0]?.TotalCount);
      setLedgerDetailsData(data?.Data);
      setIsloading(false);
    } catch {
      setIsloading(false);
      toster.current?.error("Something went wrong");
    }
  };

  useEffect(() => {
    getLeaveLedgerDataList(pageNumber, pageSize);
    setFirst(1);
    setRows(10);
  }, [
    filterStartDate,
    filterEndDate,
    selectedStatusValue,
    selectHierarchyValue,
    selectedEmployeId,

  ]);

  const onPageChange = useCallback(
    (event) => {
      setFirst(event.first);
      setRows(event.rows);
      getLeaveLedgerDataList(event.page + 1, event.rows);
    },
    [setFirst, setRows, typeAddOnClass, filterEndDate,
      selectedStatusValue,
      selectHierarchyValue,
      selectedEmployeId]
  );

  useEffect(() => { }, [ledgerDetailsData]);

  async function GetLeaveYears() {
    let params = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let LeaveYearDetails = await getLeaveYear(params);
      setLeaveYear(LeaveYearDetails?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  const setSelectHierarchy = (event) => {
    if (event.target.value == 1 ?? event.target.value == 2) {
      setSelectedEmployeId(userDetails?.EmpId);;
    }

    getEmployeeIdData(event.target.value);
  };

  //For get the employee data.
  async function getEmployeeIdData(HierarchyValue) {
    setIsEmploading(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: Number(HierarchyValue) ?? 1,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      IsSuggestedOnly: 0,
      pageNumber: 1,
      pageSize: 100000,
      EmployeeId: ApllyForOtherEmployeeId ?? userDetails?.EmpId,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      const checkSelf = employeesList?.Data
        ? (!employeesList.Data.some(item => item?.EmpId === userDetails?.EmpId)
          ? [{ id: 0, EmpId: 0, FullName: "All Employees" }]
          : []
        ).concat(employeesList.Data)
        : [];
      setEmployeeList(checkSelf);
      setIsEmploading(false);
    } catch (error) {
      setIsEmploading(false);
      // Handle error
    }
  }

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option?.FullName}
          src={option?.ProfileImage || defaultImage}
          onError={handleImageError}
          width="32"
        />
        <span>
          {option?.FullName}
          {option?.UserName?.length > 0 && ","}
        </span>
        <span>
          {option?.UserName}
          {option?.CurrentDesignation?.length > 0 && ","}
        </span>
        <span>{option?.CurrentDesignation}</span>
      </div>
    );
  };

  useEffect(() => {
    if (leaveYears?.yearLists?.length > 0 && !selectedYear) {
      setSelectedYear(leaveYears.yearLists[0].yearList);
    }
  }, [selectedYear, leaveYears]);

  const [options] = useState([
    { value: "1", label: "Mine" },
    { value: "2", label: "Direct Report" },
    { value: "3", label: "Complete Hierarchy" },
  ]);

  const [LeaveStatus] = useState([
    { value: 0, label: "All Leave's" },
    { value: 1, label: "Credit Leave" },
    { value: 2, label: "Debit Leave" },
  ]);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid position-relation">
        <div className="row g-3">
          <div className="form-head ">
            <div className="row">
              <div className="col-lg-5">
                <div className="">
                  <h2 className="font-w600 mb-0">Leave Ledger</h2>
                  <p className="text-light">{masterSystemAlertData}</p>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="rightside-tabs">
                  <LeaveNavBarItems />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-8">
            <div className="leave-card tile-grid tile-grid-v1">
                <div className="tab-tabsa2">
                  <div className="form-group d-gridcss mb-0">
                    <label>Start Date</label>
                    <input
                      type="date"
                      name="startDate"
                      onClick={(e) =>
                        e.target.showPicker &&
                        e.target.showPicker()
                      }
                      className="form-control me-2"
                      placeholder="Start Date"
                      onFocus="(this.type='date')"
                      value={filterStartDate}
                      onChange={(e) => setFilterStartDate(e.target.value)}
                    />
                    <label>End Date</label>
                    <input
                      type="date"
                      name="endDate"
                      onClick={(e) => e.target.showPicker &&
                        e.target.showPicker()
                      }
                      className="form-control"
                      placeholder="End Date"
                      onFocus="(this.type='date')"
                      value={filterEndDate}
                      onChange={(e) => setFilterEndDate(e.target.value)}
                    />
                  </div>
                  <div className="widthdiv">
                    <Dropdown
                      value={selectHierarchyValue}
                      onChange={(e) => {
                        setSelectHierarchy(e);
                        setSelectHierarchyValue(e.target.value);
                      }}
                      options={options}
                      optionLabel="label"
                      placeholder="Select Type"
                      checkmark={true}
                      highlightOnSelect={false}
                    />
                  </div>
                  <div
                    className="widthdiv"
                    style={{ marginRight: "5px", marginLeft: "3px" }}
                  >
                    <Dropdown
                      value={selectedEmployeId}
                      filter={true}
                      onChange={(e) => setSelectedEmployeId(e.target.value)}
                      options={employeeList}
                      optionLabel="FullName"
                      optionValue="EmpId"
                      itemTemplate={employeeOptionTemplate}
                      placeholder="Choose"
                      checkmark={true}
                      highlightOnSelect={false}
                    />
                  </div>
                  <div className="widthdiv">
                    <Dropdown
                      value={selectedStatusValue}
                      onChange={(event) =>
                        setselectedStatusValue(event.target.value)
                      }
                      options={LeaveStatus}
                      optionValue="value"
                      placeholder="Select Type"
                      checkmark={true}
                      highlightOnSelect={false}
                    />
                  </div>
                </div>
              {ledgerDetailsData?.map((ledger) => {
                return (
                  <div className="card bottom-card">
                    <div className="card-body p-3">
                      <div className="row">
                        <div className="col-xl-2">
                          {ledger?.LeaveEntryType == "CR" ? (
                            <img
                              src="images/org-img/leave/cr.png"
                              className="w-100"
                            />
                          ) : ledger?.LeaveEntryType == "DR" ? (
                            <img
                              src="images/org-img/leave/dr.png"
                              className="w-100"
                            />
                          ) : (
                            <img
                              src="images/org-img/leave/dr.png"
                              className="w-100"
                            />
                          )}
                        </div>
                        <div className="col-xl-3 p-3">
                          <div className="media-body px-0">
                            <h2 className="mt-0 mb-0 fss-17 darkh02">
                              {ledger?.LeaveEntryType == "DR" ? (
                                <a className="">
                                  {ledger?.leavecount != 0 ? (
                                    <a className=""> - {ledger?.leavecount} </a>
                                  ) : (
                                    <a className="">{ledger?.leavecount}</a>
                                  )}
                                </a>
                              ) : ledger?.LeaveEntryType == "CR" ? (
                                <a className="">
                                  {ledger?.leavecount != 0 ? (
                                    <a className=""> + {ledger?.leavecount} </a>
                                  ) : (
                                    <a className="">{ledger?.leavecount}</a>
                                  )}
                                </a>
                              ) : (
                                ""
                              )}
                            </h2>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              {ledger?.LeaveTypeName}
                            </span>
                          </div>
                        </div>
                        <div className="col-xl-3 p-3 m-auto">
                          <div className="media-body px-0">
                            <h2 className="mt-0 mb-0 fss-17 lighth2">
                              <a className="text-black" href="event.html">
                                {moment(ledger?.CreatedDate).format(
                                  "MMM DD YYYY"
                                )}
                              </a>
                            </h2>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              When
                            </span>
                          </div>
                        </div>
                        <div className="col-xl-4 p-3">
                          <div className="media-body px-0">
                            <h2 className="mt-0 mb-0 fss-17 darkh2">
                              <a className="" href="event.html">
                                {ledger?.TotalLeave}
                              </a>
                            </h2>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              Remaining {ledger?.LeaveTypeName} Leave
                            </span>
                          </div>
                        </div>
                        {ledger?.Comment && (
                          <div className="col-xl-12">
                            <div className="comments-section">
                              <span>Comment :</span>
                              {ledger?.Comment}.
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              {ledgerDetailsData?.length === 0 ||
                ledgerDetailsData?.length == null ? (
                <div className="card">
                  <div className="leave-notfound">
                    <img src="/images/no-data-found/leaveLedger.png" />
                    <p>{noData}</p>
                  </div>
                </div>
              ) : (
                <div className="card pagination-css">
                  <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalRecords}
                    rowsPerPageOptions={[10, 20, 30]}
                    onPageChange={onPageChange}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-4">
            <div className="row sidecarddd">
              <div className="col-xl-12">
                <LeaveManagerReport />
              </div>
            </div>
          </div>
        </div>

      </div>
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
      {IsEmploading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}



    </div>
  );
}

export default MyLedger;
